
import { Component, Prop, Vue } from 'vue-property-decorator';
import TextMenu from '@/components/menu/TextMenu.vue';

@Component<DailyMenuDefaultLayout>({
	components: {
		TextMenu
	}
})
export default class DailyMenuDefaultLayout extends Vue {
	@Prop({ type: Array, required: true }) private menus!: Menu[];
	@Prop({ type: String, required: false, default: 'vertical' }) private cardStyle!: string;
	@Prop({ type: String, required: false, default: null }) private k12TitleDisplay!: string | null;
}
